<template functional>
  <nuxt-link
    :to="{ name: 'template-detail', params: { slug: props.template.slug } }"
    class="saas-template-card"
  >
    <div class="saas-template-card__head">
      <div class="saas-template-card__icon">
        <i :class="props.template.icon"></i>
      </div>
      <div class="saas-template-card__name-and-category">
        <div class="saas-template-card__name">
          {{ props.template.name }}
        </div>
        <div
          v-if="props.category !== null"
          class="saas-template-card__category"
        >
          {{ props.category.name }}
        </div>
      </div>
    </div>
    <p class="saas-template-card__description">
      {{ props.template.short_description }}
    </p>
    <!-- <div class="saas-template-card__foot">
      <component
        :is="$options.components.TemplateLevel"
        :level="props.template.level"
      ></component>
    </div> -->
  </nuxt-link>
</template>

<script>
export default {
  name: 'TemplateCard',
  props: {
    template: {
      type: Object,
      required: true,
    },
    category: {
      type: Object,
      required: false,
      default: null,
    },
  },
}
</script>
